import { Button, ButtonProps, styled } from "@mui/material";

const ButtonExchange = styled(Button)<ButtonProps>(({ theme }) => ({
  color: "#fff",
  fontWeight: 600,
  backgroundColor: "#21B526",
  minWidth: "40px",
  width: "40px",
  height: "40px",
  padding: 2,
  "&:hover": {
    backgroundColor: "#21B526",
  },
  "&:disabled": {
    opacity: 0.5,
    color: "#fff",
  },
}));

export default ButtonExchange;
